// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"src-components-Dashboard-Charts-Legend-Tooltip-module__tooltip--EMz9o"};